import { Sparkles, Lock } from 'lucide-react';
import { PACKAGES, CAMPAIGNS, fmt } from '../lib/pricing';
import OfferActions from './OfferActions';

export default function OrderSummary({ order, price, step }) {
  const selection =
    order.kind === 'package' ? PACKAGES.find((p) => p.id === order.selectionId)
      : order.kind === 'campaign' ? CAMPAIGNS.find((c) => c.id === order.selectionId) : null;
  const title = order.kind === 'beratung' ? 'Beratung vor Ort' : selection ? selection.name : 'Noch nichts ausgewählt';

  return (
    <aside className="panel p-7 lg:sticky lg:top-24" data-testid="order-summary">
      <div className="flex items-center justify-between">
        <p className="eyebrow">Ihre Zusammenfassung</p>
        <span className="font-mono-num text-[10px] text-[#7D8391]">Schritt {step}/5</span>
      </div>
      <h3 className="mt-3 font-display text-2xl font-extrabold tracking-tight" data-testid="summary-selection">{title}</h3>
      {order.kind === 'package' && order.founder && (
        <p className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-[#FF6B00]/15 px-3 py-1 font-mono-num text-[10px] font-bold uppercase tracking-widest text-[#FF6B00]" data-testid="summary-founder-badge">
          <Sparkles className="h-3 w-3" /> Gründungspartner
        </p>
      )}

      <div className="mt-6 space-y-3 border-t border-[#282C37] pt-5">
        {price.lines.length === 0 && <p className="t-muted">Wählen Sie ein Paket oder eine Kampagne – der Preis erscheint sofort hier.</p>}
        {price.lines.map((l, i) => (
          <div key={`${l.label}-${l.amount}`} className="flex items-start justify-between gap-4 text-sm" data-testid={`summary-line-${i}`}>
            <span className="text-[#B6BCC8]">{l.label}</span>
            <span className={`shrink-0 font-mono-num font-semibold ${l.amount < 0 ? 'text-emerald-400' : 'text-white'}`}>
              {l.amount < 0 ? '− ' : ''}{fmt(Math.abs(l.amount))}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-6 space-y-2.5 border-t border-[#282C37] pt-5">
        {order.kind === 'package' && selection && (
          <div className="flex justify-between text-sm">
            <span className="text-[#B6BCC8]">pro Monat netto</span>
            <span className="font-mono-num font-semibold" data-testid="summary-monthly">{fmt(price.monthly)}</span>
          </div>
        )}
        <div className="flex items-baseline justify-between">
          <span className="text-sm text-[#B6BCC8]">Gesamt netto</span>
          <span className="font-mono-num text-2xl font-bold text-[#FF6B00]" data-testid="summary-total-netto">{fmt(price.totalNetto)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-[#7D8391]">zzgl. 19 % USt.</span>
          <span className="font-mono-num text-[#B6BCC8]" data-testid="summary-vat">{fmt(price.vat)}</span>
        </div>
        <div className="flex justify-between border-t border-[#282C37] pt-3 text-sm">
          <span className="font-semibold">Gesamt brutto</span>
          <span className="font-mono-num font-bold" data-testid="summary-total-brutto">{fmt(price.brutto)}</span>
        </div>
      </div>

      <p className="t-muted mt-5 flex items-start gap-2 !text-xs">
        <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        Zahlung auf Rechnung. Verbindlich wird der Auftrag erst mit unserer Bestätigung in Textform.
      </p>

      <OfferActions order={order} price={price} />
    </aside>
  );
}
